import { useCallback, useSyncExternalStore } from "react";

// SSR-safe matchMedia через useSyncExternalStore.
// Не падает в Capacitor preflight'е до DOM hydration.
export function useMediaQuery(query: string): boolean {
	const subscribe = useCallback(
		(callback: () => void) => {
			if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
				return () => {};
			}
			const mql = window.matchMedia(query);
			mql.addEventListener("change", callback);
			return () => mql.removeEventListener("change", callback);
		},
		[query],
	);

	const getSnapshot = useCallback(() => {
		if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
			return false;
		}
		return window.matchMedia(query).matches;
	}, [query]);

	const getServerSnapshot = useCallback(() => false, []);

	return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
